import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

const messages = {
  ko: {
    ...require('@/locales/ko/global.json').data,
    ...require('@/locales/ko/main.json').data,
    ...require('@/locales/ko/company.json').data,
    ...require('@/locales/ko/ethics.json').data,
    ...require('@/locales/ko/history.json').data,
    ...require('@/locales/ko/compliancereport.json').data,
    ...require('@/locales/ko/consult.json').data,
    ...require('@/locales/ko/fonts.json').data,
    ...require('@/locales/ko/informationcenter.json').data,
    ...require('@/locales/ko/music.json').data,
    ...require('@/locales/ko/newsroom.json').data,
    ...require('@/locales/ko/notice.json').data,
    ...require('@/locales/ko/place.json').data,
    ...require('@/locales/ko/policy.json').data,
    ...require('@/locales/ko/question.json').data,
    ...require('@/locales/ko/service.json').data,
    ...require('@/locales/ko/sustainability.json').data,
    ...require('@/locales/ko/writing.json').data,
  },
  en: {
    ...require('@/locales/en/global.json').data,
    ...require('@/locales/en/main.json').data,
    ...require('@/locales/en/company.json').data,
    ...require('@/locales/en/ethics.json').data,
    ...require('@/locales/en/history.json').data,
    ...require('@/locales/en/compliancereport.json').data,
    ...require('@/locales/en/consult.json').data,
    ...require('@/locales/en/fonts.json').data,
    ...require('@/locales/en/informationcenter.json').data,
    ...require('@/locales/en/music.json').data,
    ...require('@/locales/en/newsroom.json').data,
    ...require('@/locales/en/notice.json').data,
    ...require('@/locales/en/place.json').data,
    ...require('@/locales/en/policy.json').data,
    ...require('@/locales/en/question.json').data,
    ...require('@/locales/en/service.json').data,
    ...require('@/locales/en/sustainability.json').data,
    ...require('@/locales/en/writing.json').data,
  },
}

export const checkDefaultLanguage = () => {
  let matched = null
  const languages = Object.getOwnPropertyNames(messages)
  languages.forEach(lang => {
    if (lang === (window.localStorage.lang || navigator.language || navigator.userLanguage)) {
      matched = lang
    }
  })
  if (!matched) {
    languages.forEach(lang => {
      const languagePartials = (window.localStorage.lang || navigator.language || navigator.userLanguage).split('-')[0]
      if (lang === languagePartials) {
        matched = lang
      }
    })
  }

  if (/bot|googlebot|crawler|spider|robot|crawling/i.test(navigator.userAgent)) {
    matched = 'ko'
  }

  return matched
}

export default new VueI18n({
  // locale: process.env.VUE_APP_I18N_LOCALE || 'ko',
  locale: checkDefaultLanguage() || 'ko',
  // fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'ko',
  fallbackLocale: checkDefaultLanguage() || 'ko',
  messages,
  silentTranslationWarn: true
})
